import moment from 'moment'
import { DATE_FORMAT_MAP } from 'utils/constants'
import { formatDateForPicker, parseDateForPicker } from 'components/DayPickerInput'
import { dayPickerConfig } from 'utils/time'

export const isPastVisitDate = date => date && moment(date).isValid() && moment(date).isBefore(moment(), 'day')

/**
 * True when input fully matches the active picker format (build locale).
 * EN: "30 May 2024" (dd MMM yyyy) · CN: "2024年5月30日" (yyyy年M月d日)
 */
export const hasCompleteAdhocDateInput = (inputValue = '') => {
  const trimmed = inputValue.trim()
  if (!trimmed) return false
  const { formatDateFns: fmt, locale } = dayPickerConfig
  const parsed = parseDateForPicker(trimmed, fmt, locale)
  if (!parsed) return false
  return formatDateForPicker(parsed, fmt, locale) === trimmed
}

export const getParsedMomentFromRawInput = rawValue => {
  if (!hasCompleteAdhocDateInput(rawValue)) return null
  const parsed = parseDateForPicker(rawValue, dayPickerConfig.formatDateFns, dayPickerConfig.locale)
  return parsed ? moment(parsed) : null
}

/** Validate manual keystrokes (onChangeRaw). Only when the date string is complete. */
export const getIsPastFromRawInput = rawValue => {
  const date = getParsedMomentFromRawInput(rawValue)
  return date ? isPastVisitDate(date) : false
}

export const isFutureDate = date => date && moment(date).isValid() && moment(date).isAfter(moment(), 'day')

/** Validate manual keystrokes (onChangeRaw). Only when the date string is complete. */
export const getIsFutureFromRawInput = rawValue => {
  const date = getParsedMomentFromRawInput(rawValue)
  return date ? isFutureDate(date) : false
}

const getPtpAdhocVisitErrors = ptpVisit => {
  const errors = {}
  const { adhocVisitSchedule, checkedPtp, displayName, visitName } = ptpVisit
  const selectedScheduleKey = Object.keys(adhocVisitSchedule).filter(key => adhocVisitSchedule[key].isSelected)[0]
  const { value, visit } = adhocVisitSchedule[selectedScheduleKey]
  if (!visitName || visitName === '') errors.visitName = 'Visit Name cannot be empty'
  if (!displayName || displayName === '') errors.displayName = 'Visit Display Name cannot be empty'
  if (Object.keys(checkedPtp).length === 0) errors.checkedPtp = 'Participant must be selected'
  switch (selectedScheduleKey) {
    case 'specificDate': {
      if (!value || value === '') {
        errors.specificDate = 'Please enter a valid Visit Date'
      } else {
        const parsed = moment(value, DATE_FORMAT_MAP.datePickerWithFullTime, true)
        if (!parsed.isValid() || parsed.format(DATE_FORMAT_MAP.datePickerWithFullTime) !== value) {
          errors.specificDate = 'Please check the format of the Visit Date'
        } else if (parsed.isBefore(moment(), 'day')) {
          errors.specificDate = 'Visit Date cannot be in the past'
        }
      }
      break
    }
    case 'daysBeforeVisit':
      if (!visit.key || visit.key === '') errors.visitSelection = 'Please select a visit'
      break
    default:
      break
  }
  return errors
}

export default getPtpAdhocVisitErrors
